import { render, staticRenderFns } from "./PrimaryInsurance.vue?vue&type=template&id=ee6305b2"
import script from "./PrimaryInsurance.vue?vue&type=script&lang=js"
export * from "./PrimaryInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports